/**
 * Function to detect if Internet Explorer is being used based on
 * userAgent contents.
 * Returns true if Internet Explorer (all versions up to and including 11) is used
 */
export const isInternetExplorer = () =>
  window.navigator.userAgent.includes('MSIE ') ||
  window.navigator.userAgent.includes('Trident/');
